export default __webpack_public_path__ + "static/media/bar-chart.d1a1278a.svg";